import React from 'react';
import styled from 'styled-components';
import { useTranslation as i18nUseTranslation } from 'react-i18next';

import useTranslation from '@src/hooks/useTranslation';
import { IconComponent } from '@src/icons';
import useLanguageSelection from '@src/hooks/useLanguageSelection';
import { normalizeLanguage } from '@src/i18n/languagePolicy';
import { LANGUAGE_NAME_I18N_KEYS } from '@src/const/common';

const FlexRow = styled.div`
	display: flex;
	flex-direction: column;
`;

const ClickableText = styled.div`
	cursor: pointer;
	text-decoration: underline;
`;

const ModalFooterInfo = (): JSX.Element => {
	const { t } = useTranslation();
	const { i18n } = i18nUseTranslation();
	const { selectLanguage } = useLanguageSelection();

	return (
		<>
			<p>
				{t('share:auth:agreement:prefix')}
				<br />
				<FlexRow>
					<ClickableText onClick={() => window.open('/p/terms')}>
						{t('share:auth:agreement:terms')}
					</ClickableText>
					<ClickableText onClick={() => window.open('/p/policy')}>
						{t('share:auth:agreement:privacy')}
					</ClickableText>
				</FlexRow>
			</p>
			<div className="lang-box">
				<IconComponent size={17} color="#222" icon="login_form_Language" />
				<select
					value={normalizeLanguage(i18n.language)}
					onChange={event => selectLanguage(normalizeLanguage(event.target.value))}
				>
					<option value="zh-CHT">{t(LANGUAGE_NAME_I18N_KEYS['zh-tw'])}</option>
					<option value="en">{t(LANGUAGE_NAME_I18N_KEYS.en)}</option>
				</select>
			</div>
		</>
	);
};

export default ModalFooterInfo;
